// One way to open an external link across iOS, Android and web.
//
// On native we use the Capacitor in-app browser (keeps the user inside the app
// shell). On web, Capacitor's Browser.open runs window.open inside an async
// promise — by then the user-gesture has lapsed and pop-up blockers silently
// swallow it (this is why Privacy / Terms "did nothing" on app.renurture.org).
// On web we therefore open a real new tab SYNCHRONOUSLY in the click handler so
// it counts as user-initiated.
//
// We use a programmatic anchor click rather than window.open(url,'_blank',
// 'noopener,noreferrer'): with `noopener` set, window.open returns null even on
// SUCCESS, so the old `if (!w) location.href = url` fallback always fired too —
// the link opened in a new tab AND navigated the current tab away from the app.
// An <a target="_blank" rel="noopener noreferrer"> click opens the new tab,
// leaves the current tab on the app, and keeps the security hardening.
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export function openExternal(url: string): void {
  if (Capacitor.isNativePlatform()) {
    void Browser.open({ url }).catch(() => {});
    return;
  }
  // Web: new tab only — the current tab (the app) stays put.
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
